import React from 'react'
import Shanmedical from './Shanmedical'
import Navbar from '../inc/Navbar'

import {Link } from "react-router-dom";
function Shanpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        
        <div className='color'>
          <div className="album py-1">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"> Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Clinic </li>
                            </ol>
                        </nav>
                    </div>
                </div>
                </div>
                <br/>
        <Shanmedical/>
        <br/>
    
    </div>
  )
}

export default Shanpage